import React, { useState } from 'react';

const VIDEO_SRC = '/login-bg.mp4';

export default function Register({ onLogin, onShowLogin }) {
  const [business, setBusiness] = useState('');
  const [name, setName]         = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Las contraseñas no coinciden'); return; }
    if (password.length < 8)  { setError('La contraseña debe tener al menos 8 caracteres'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://talku.online/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ business_name: business, name, email, password }),
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('talku_token', data.token);
        onLogin({ id: data.id, email: data.email, name: data.name, role: data.role, token: data.token, tenant_id: data.tenant_id });
      } else {
        setError(data.detail || 'Error al crear la cuenta');
      }
    } catch {
      setError('Error de conexión. Intenta de nuevo.');
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
        /* Inter loaded from index.html */
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        .rg-screen { display: flex; height: 100vh; font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: #fff; overflow: hidden; }
        .rg-left { width: 480px; flex-shrink: 0; display: flex; flex-direction: column; align-items: center; justify-content: space-between; padding: 40px 52px 36px; background: #fff; position: relative; z-index: 2; overflow-y: auto; }
        .rg-logo-wrap { display: flex; align-items: center; flex-shrink: 0; }
        .rg-logo-wrap img { height: 60px; width: auto; object-fit: contain; mix-blend-mode: multiply; }
        .rg-form-body { width: 100%; display: flex; flex-direction: column; gap: 0; }
        .rg-headline { font-size: 24px; font-weight: 700; color: #0a0a0a; letter-spacing: -0.5px; line-height: 1.25; margin-top: 20px; margin-bottom: 4px; }
        .rg-sub { font-size: 13px; color: #9ca3af; margin-bottom: 22px; line-height: 1.5; }
        .rg-field-box { background: #f5f5f3; border-radius: 14px; padding: 16px 18px; display: flex; flex-direction: column; gap: 10px; margin-bottom: 14px; }
        .rg-field { display: flex; align-items: center; gap: 10px; background: #fff; border: 1.5px solid #e8e8e6; border-radius: 10px; padding: 0 14px; height: 46px; transition: border-color 0.15s; }
        .rg-field:focus-within { border-color: #0a0a0a; }
        .rg-field svg { flex-shrink: 0; color: #9ca3af; }
        .rg-field input { flex: 1; border: none; outline: none; font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; font-size: 13px; color: #0a0a0a; background: transparent; }
        .rg-field input::placeholder { color: #c4c4c4; }
        .rg-eye { background: none; border: none; cursor: pointer; padding: 0; color: #9ca3af; display: flex; align-items: center; line-height: 0; }
        .rg-btn-main { width: 100%; height: 50px; background: #0a0a0a; color: #fff; border: none; border-radius: 12px; font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; font-size: 14px; font-weight: 700; cursor: pointer; letter-spacing: 0.01em; transition: opacity 0.15s; margin-bottom: 14px; }
        .rg-btn-main:disabled { opacity: 0.6; cursor: not-allowed; }
        .rg-btn-main:hover:not(:disabled) { opacity: 0.88; }
        .rg-login-link { text-align: center; font-size: 12.5px; color: #9ca3af; }
        .rg-login-link a { color: #0a0a0a; font-weight: 700; text-decoration: none; cursor: pointer; }
        .rg-login-link a:hover { text-decoration: underline; }
        .rg-error { font-size: 12px; color: #ef4444; margin-bottom: 10px; padding: 8px 12px; background: #fef2f2; border-radius: 8px; border: 1px solid #fecaca; }
        .rg-plan-badge { display: inline-flex; align-items: center; gap: 6px; background: #f0fdf4; border: 1px solid #bbf7d0; color: #16a34a; font-size: 11.5px; font-weight: 700; padding: 6px 12px; border-radius: 8px; margin-bottom: 16px; }
        .rg-right { flex: 1; position: relative; overflow: hidden; margin: 24px 24px 24px 12px; border-radius: 30px; box-shadow: 0 24px 60px -28px rgba(0,0,0,0.30), inset 0 0 0 1px rgba(255,255,255,0.10); isolation: isolate; }
        .rg-video { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
        .rg-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.42) 0%, rgba(0,0,0,0.12) 34%, rgba(0,0,0,0) 62%); display: flex; flex-direction: column; justify-content: flex-end; padding: 56px 56px 56px; }
        .rg-glass-card { position: relative; background: rgba(255,255,255,0.10); backdrop-filter: blur(22px) saturate(1.05); -webkit-backdrop-filter: blur(22px) saturate(1.05); border: 1px solid rgba(255,255,255,0.16); border-radius: 22px; padding: 28px 30px; max-width: 400px; box-shadow: 0 18px 44px -24px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.22); }
        .rg-glass-title { font-size: 25px; font-weight: 600; color: #fff; letter-spacing: -0.3px; line-height: 1.25; margin-bottom: 10px; }
        .rg-glass-sub { font-size: 14px; color: rgba(255,255,255,0.65); line-height: 1.65; }
        .rg-steps { display: flex; flex-direction: column; gap: 10px; margin-top: 20px; }
        .rg-step { display: flex; align-items: center; gap: 12px; }
        .rg-step-dot { width: 24px; height: 24px; border-radius: 50%; background: rgba(255,255,255,0.14); border: 1px solid rgba(255,255,255,0.22); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .rg-step-dot span { font-size: 11px; font-weight: 700; color: rgba(255,255,255,0.92); }
        .rg-step-text { font-size: 13px; color: rgba(255,255,255,0.75); }
        @media (max-width: 860px) {
          .rg-screen { flex-direction: column; height: auto; min-height: 100vh; }
          .rg-right { order: -1; height: 240px; flex: none; width: auto; margin: 14px 14px 4px 14px; border-radius: 26px; }
          .rg-left { width: 100%; padding: 28px 24px; }
          .rg-overlay { padding: 24px; }
        }
      `}</style>

      <div className="rg-screen">
        <div className="rg-left">
          <div className="rg-logo-wrap">
            <img src="/logo-talku.png" alt="Talku" />
          </div>

          <div className="rg-form-body">
            <h1 className="rg-headline">Crea tu cuenta en Talku</h1>
            <p className="rg-sub">14 días gratis · Sin tarjeta de crédito</p>

            <div className="rg-plan-badge">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              Plan Trial — acceso completo 14 días
            </div>

            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <div className="rg-field-box">
                <div className="rg-field">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                  <input type="text" placeholder="Nombre de tu negocio" value={business} onChange={e => setBusiness(e.target.value)} required autoComplete="organization" />
                </div>
                <div className="rg-field">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <input type="text" placeholder="Tu nombre completo" value={name} onChange={e => setName(e.target.value)} required autoComplete="name" />
                </div>
                <div className="rg-field">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="3"/>
                    <path d="M2 7l10 7 10-7"/>
                  </svg>
                  <input type="email" placeholder="correo@empresa.com" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" />
                </div>
                <div className="rg-field">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input type={showPass ? 'text' : 'password'} placeholder="Contraseña (mín. 8 caracteres)" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="new-password" />
                  <button type="button" className="rg-eye" onClick={() => setShowPass(v => !v)} tabIndex={-1}>
                    {showPass
                      ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                      : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    }
                  </button>
                </div>
                <div className="rg-field">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <input type={showPass ? 'text' : 'password'} placeholder="Confirmar contraseña" value={confirm} onChange={e => setConfirm(e.target.value)} required autoComplete="new-password" />
                </div>
              </div>

              {error && <div className="rg-error">{error}</div>}

              <button type="submit" className="rg-btn-main" disabled={loading}>
                {loading ? 'Creando cuenta...' : 'Crear cuenta gratis'}
              </button>
            </form>

            <p className="rg-login-link">
              ¿Ya tienes cuenta?{' '}
              <a onClick={onShowLogin}>Inicia sesión</a>
            </p>
          </div>

          <div style={{ height: 1 }} />
        </div>

        <div className="rg-right">
          <video className="rg-video" src={VIDEO_SRC} poster="/login-poster.webp" preload="auto" autoPlay loop muted playsInline />
          <div className="rg-overlay">
            <div className="rg-glass-card">
              <div className="rg-glass-title">Tu CRM listo en minutos</div>
              <div className="rg-glass-sub">Conecta WhatsApp, Shopify y tus carriers en un solo lugar.</div>
              <div className="rg-steps">
                {[
                  { n: '1', t: 'Crea tu cuenta' },
                  { n: '2', t: 'Conecta WhatsApp Business' },
                  { n: '3', t: 'Empieza a gestionar' },
                ].map(s => (
                  <div className="rg-step" key={s.n}>
                    <div className="rg-step-dot"><span>{s.n}</span></div>
                    <div className="rg-step-text">{s.t}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
